



























































import { Component, Prop, Vue } from "vue-property-decorator";
import ListPenunjangLain from "@/components/pemeriksaan/penunjang/ListPenunjangLain.vue";
import CardRiwayatPenunjangLain from "@/components/pemeriksaan/penunjang/CardRiwayatPenunjangLain.vue";
import { storePenunjang } from "@/store/modules/penunjang";
import { userModule } from "@/store/modules/user";
import ModalPenunjangLain from "@/components/modal/CardPenunjangLain.vue";

@Component({
  components: {
    ListPenunjangLain,
    CardRiwayatPenunjangLain,
    ModalPenunjangLain
  }
})
export default class CardPenunjangLain extends Vue {
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() type!: string;
  @Prop({ default: false }) readOnly!: boolean;

  tglIsi = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  tglShow = false;
  // maxDate = new Date().toISOString().substr(0, 10);
  tab = "riwayat-penunjang-lain";
  modalOpen = false;
  penunjanglain = {};
  panelriwayat = [];
  showdetail = false;

  mounted() {
    storePenunjang.act_kategori_penunjang_lain();
    storePenunjang.act_kb_metode();
    storePenunjang.act_penunjang_lain_byReg(this.register);
    storePenunjang.act_penunjang_lain_byRm(this.rm);
  }

  get stateUser() {
    return userModule.user;
  }

  get canAddItem() {
    // Dokter unit Laboratorium (c_upm '31', incl. Sp.PK) tetap dapat menambah
    // hasil penunjang meski episode pasien sudah read-only — hasil kultur
    // mikrobiologi tipikal selesai 3–7 hari setelah pasien pulang.
    if (
      this.stateUser.unit_id === "31" &&
      this.stateUser.profesi === "Dokter"
    ) {
      return true;
    }
    return (
      !this.readOnly &&
      ["Dokter", "Perawat", "Bidan"].includes(this.stateUser.profesi)
    );
  }

  tambah() {
    // storeKonsul.act_on_reg_new_konsul(this.register);
    this.penunjanglain = {};
    this.modalOpen = true;
  }
  tabRiwayat() {
    storePenunjang.act_penunjang_lain_byRm(this.rm);
    // this.panelriwayat = [];
    this.showdetail = true;
  }
  tabByRegister() {
    storePenunjang.act_penunjang_lain_byReg(this.register);
    this.showdetail = false;
  }
}
